import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'boolConvert'
})
export class BoolConvertPipe implements PipeTransform {
    constructor() {
    }

    async transform(value: any) {
        if (value == null) {
            return  '';
        }
        if (value === true || value.toString().toLowerCase() == 'true') {
            return '是';
        } else if (value === false || value.toString().toLowerCase() == 'false') {
            return '否';
        } else {
            return value;
        }
    }
}
